import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { DonationProvider } from './context/DonationContext';
import Home from './pages/Home';
import DonationFlow from './pages/DonationFlow';
import ThankYou from './pages/ThankYou';
import Error from './pages/Error';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import PersonalInfo from './components/donation/PersonalInfo';
import PaymentInfo from './components/donation/PaymentInfo';
import Confirmation from './components/donation/Confirmation';
import CreditCard from './components/donation/CreditCard';
import PayPal from './components/donation/PayPal';
import Oxxo from './components/donation/Oxxo';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Contact from './pages/Contact';

function App() {
  return (
    <BrowserRouter>
      <DonationProvider>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/donar" element={<DonationFlow />}>
            <Route path="informacion" element={<PersonalInfo />} />
            <Route path="pago" element={<PaymentInfo />} />
            <Route path="confirmacion" element={<Confirmation />} />
          </Route>
          <Route path="/pago/tarjeta" element={<CreditCard />} />
          <Route path="/pago/paypal" element={<PayPal />} />
          <Route path="/pago/oxxo" element={<Oxxo />} />
          <Route path="/gracias/:id" element={<ThankYou />} />
          {/* <Route path="/gracias/" element={<ThankYou />} /> */}
          <Route path="*" element={<Error />} />
          <Route path="/terminos" element={<TermsAndConditions />} />
          <Route path="/privacidad" element={<PrivacyPolicy />} />
          <Route path="/contacto" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster position="top-right" />
      </DonationProvider>
    </BrowserRouter>
  );
}

export default App;